const MARKET_TRADE_SCAN_WINDOW_MS: number = 24 * 60 * 60 * 1000;
const MARKET_TRADE_SCAN_GRANULARITY_MS: number = 60 * 1000;

/** Stable lower bound shared by market-card, detail, and SSR trade snapshots. */
export function marketTradeScanFrom(startedAtMs: number = Date.now()): string {
  const startMinuteMs =
    Math.floor(startedAtMs / MARKET_TRADE_SCAN_GRANULARITY_MS) * MARKET_TRADE_SCAN_GRANULARITY_MS;
  return new Date(startMinuteMs - MARKET_TRADE_SCAN_WINDOW_MS).toISOString();
}

/**
 * Bounded REST lower bound for live-trade overlays.
 *
 * Animation freshness comes from the SDK's NATS-arrival `liveSinceMountIds`
 * projection, rather than the chain timestamp. Reuse the normal scan window
 * so a temporarily stale validator clock cannot discard a trade that just
 * arrived on the live feed.
 */
export function marketTradeLiveFrom(startedAtMs: number = Date.now()): string {
  return marketTradeScanFrom(startedAtMs);
}
